import React from "react";

export const CyberMondayUpgradeMessage: React.FC = () => {
  return (
    <div style={{ display: "inline-block" }}>
      💸️💥 <b>Cyber Monday Deal!</b> For a limited time, <b>get 30% off</b> when you upgrade!
    </div>
  );
};
